import React from 'react';
import './MobileProductChips.css';

interface Product {
  id: string;
  name: string;
  icon: string;
}

interface MobileProductChipsProps {
  selectedProduct: string;
  onProductSelect: (productId: string) => void;
}

const MOBILE_PRODUCTS: Product[] = [
  { id: 'rise-fall', name: 'Rise/Fall', icon: '↗' },
  { id: 'higher-lower', name: 'Higher/Lower', icon: '⇅' },
  { id: 'matches-differs', name: 'Matches/Differs', icon: '⊕' },
  { id: 'even-odd', name: 'Even/Odd', icon: '◐' },
  { id: 'over-under', name: 'Over/Under', icon: '⪋' },
  { id: 'accumulator', name: 'Accumulator', icon: '📈' }
];

const MobileProductChips: React.FC<MobileProductChipsProps> = ({
  selectedProduct,
  onProductSelect
}) => {
  return (
    <section className="mobile-product-selector">
      <div className="product-chips">
        {MOBILE_PRODUCTS.map(product => (
          <div
            key={product.id}
            className={`product-chip ${selectedProduct === product.id ? 'active' : ''}`}
            onClick={() => onProductSelect(product.id)}
          >
            <div className="product-icon">{product.icon}</div>
            <span className="product-name">{product.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MobileProductChips;
export { MobileProductChips };
